module.exports = __webpack_public_path__ + "img/pocket-9_en.982c55e.jpg";